import React, { useState, useRef, useEffect } from "react";
import API from "../Services/Report";
import CenterModal from "../Components/CenterSelectorModal";
import css from "../../src/Report/style.css";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import * as XLSX from "xlsx";
import moment from "moment";
const CustomerAnalyticsReport = () => {
    const [selectedReport, setSelectedReport] = useState(null);
    const [analyticsReport, setAnalyticsReport] = useState({});
    const [profilingData, setProfilingData] = useState([]);
    const [selectedCenter, setSelectedCenter] = useState([]);
    const [activeTab, setActiveTab] = useState("");
    const [membershipCount, setMembershipCount] = useState({});
    const [waiverData, setWaiverData] = useState([]);
    const [resetTrigger, setResetTrigger] = useState(0);
    const [customerData, setCustomerData] = useState([]);
    const [customerWaiverData, setCustomerWaiverData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showWaiverModal, setShowWaiverModal] = useState(false);

    const today = new Date();
    const formattedToday = today.toISOString().split("T")[0];
    const pastDate = new Date();
    pastDate.setDate(pastDate.getDate() - 90);
    const formattedPastDate = pastDate.toISOString().split("T")[0];
    const [currentPage, setCurrentPage] = useState(1);
    const tableRef = useRef(null);
    const [totalPages, setTotalPages] = useState(1);
    const [selectedRange, setSelectedRange] = useState(null);
    const [centerID, setCenterID] = useState(null);
    const [search, setSearch] = useState({
        searchText: "",
        // from_date: "",
        // to_date: "",
        from_date: formattedToday,
        to_date: formattedToday,
    });

    useEffect(() => {
        if (!selectedReport) return;

        if (selectedReport === "report1") getCustomerAnalyticsData([]);
        if (selectedReport === "report2") getProfilingData([]);
        if (selectedReport === "report3") getMemberShipData([]);
        if (selectedReport === "report4") getWaiverData([]);

    }, [selectedReport]);

    const getPayload = (centers = null) => {
        const finalCenters = centers !== null ? centers : selectedCenter;

        const location_id = Array.isArray(finalCenters)
            ? finalCenters.length > 0
                ? finalCenters.join(",")
                : null
            : finalCenters;

        return {
            location_id,
            start_date: search.from_date || formattedPastDate,
            end_date: search.to_date || formattedToday,
        };
    };

    const getCustomerAnalyticsData = async (centers = null) => {
        try {
            const res = await API.getCustomerAnalytics(getPayload(centers));
            setAnalyticsReport(res?.data?.result || []);
        } catch (error) {
            handleError(error);
        }
    };

    const getProfilingData = async (centers = null) => {
        try {
            const res = await API.getCustomerReportByAge(getPayload(centers));
            setProfilingData(res?.data?.result || []);
        } catch (error) {
            handleError(error);
        }
    };

    const getMemberShipData = async (centers = null) => {
        try {
            const centerlist = Array.isArray(selectedCenter)
                ? selectedCenter.join(",")
                : selectedCenter;

            const payLoad = {
                // location_id: centerlist || null,
                // start_date: null,
                // end_date: null,

                 start_date: search.from_date || formattedPastDate,
                end_date: search.to_date || formattedToday,
                location_id: centerlist || null,
                
            }
            const res = await API.getCustomerMembershipReport(payLoad);
            setMembershipCount(res?.data?.result || []);
        } catch (error) {
            handleError(error);
        }
    };

    const getWaiverData = async (centers = null) => {
        try {
            const res = await API.getCustomerVisitFrequencyByWaiverReport(getPayload(centers));
            setWaiverData(res?.data?.result || []);
        } catch (error) {
            handleError(error);
        }
    };

    const handleError = (error) => {
        if (error?.response?.status === 403) {
            window.location.replace("/Login");
        } else {
            toast.error(error?.response?.data?.message || "Something went wrong");
        }
    };

    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
        setSelectedCenter([]);
        setResetTrigger((p) => p + 1);
        setSearch({
            from_date: formattedToday,
            to_date: formattedToday,
        });

        switch (tabId) {
            case "visit":
                setSelectedReport("report1");
                break;
            case "customer":
                setSelectedReport("report2");
                break;
            case "memberShip":
                setSelectedReport("report3");
                break;
            case "waiver":
                setSelectedReport("report4");
                break;
            default:
                break;
        }
    };
    const handleSelectedCenter = (selectedData) => {
        setSelectedCenter(selectedData);
    };

    const tabs = [
        { id: "visit", label: "Visit Frequency Report", icon: "mdi mdi-account-group" },
        { id: "customer", label: "Customer Profiling Report", icon: "mdi mdi-face-man-profile" },
        { id: "memberShip", label: "MemberShip Report", icon: "mdi mdi-wallet-membership" },
        { id: "waiver", label: "Waiver Report", icon: "mdi mdi-list-box-outline" },
    ];

    const handleSearch = () => {
        //console.log('selectedReport',selectedReport);
        if (selectedReport === '' || selectedReport === null) {
            toast.error("Please Select Any Tab")
            return;
        }
        if (selectedReport === "report1") getCustomerAnalyticsData();
        if (selectedReport === "report2") getProfilingData();
        if (selectedReport === "report3") getMemberShipData();
        if (selectedReport === "report4") getWaiverData();

    };

    const handleFieldChange1 = (e, fieldName) => {
        const value = e.target.value;

        if (fieldName === "from_date") {
            const newToDate = moment(value).add(90, "days");

            const finalToDate = newToDate.isAfter(moment())
                ? moment().format("YYYY-MM-DD")
                : newToDate.format("YYYY-MM-DD");

            setSearch((prev) => ({
                ...prev,
                from_date: value,
                to_date: finalToDate
            }));
        } else {
            setSearch((prev) => ({
                ...prev,
                [fieldName]: value
            }));
        }
    };
    const downloadCSV = async (centers = null) => {
        try {
            const centerlist = Array.isArray(selectedCenter)
                ? selectedCenter.join(",")
                : selectedCenter;

            const payLoad = {
                ///location_id: centerlist || null,
                // start_date: null,
                // end_date: null,
                // mobile: null,
                // membership: null,
                // center: centerlist || null,
                // limit: 0
                start_date: search.from_date || formattedPastDate,
                end_date: search.to_date || formattedToday,
                mobile: null,
                membership: null,
                center: centerlist || null,
                limit: 0
            }
            let response;
            let fileName = "Report";
            let result;
            response = await API.getAllCustomerMembershipReport(payLoad);;
            // console.log('rrrrr',response?.data);

            result = response?.data?.data || [];
            fileName = "MembershipSummaryReport";

            if (!result.length) {
                toast.error("No data found!");
                return;
            }

            const worksheet = XLSX.utils.json_to_sheet(result);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Report");
            XLSX.writeFile(
                workbook,
                `${fileName}.xlsx`
            );
        } catch (error) {
            console.error("Error downloading Excel:", error);
        }
    };
    const handleClick = async (key, value, rowData, centerId) => {
        let number = 0;

        if (key.includes(">")) {
            number = parseInt(key.split(">")[1].trim());
        } else if (key.includes("=")) {
            number = parseInt(key.split("=")[1].trim());
        }

        setCenterID(centerId)
        setSelectedRange(number);
        setCurrentPage(1);
        await fetchCustomerData(number, 1, centerId);
    };
    const fetchCustomerData = async (range, page, centerId) => {
        try {
            const payLoad = {
                range: range,
                mobile: "",
                date_from: search.from_date || formattedPastDate,
                date_to: search.to_date || formattedToday,
                page: page,
                page_size: 10,
                location_id: centerId
            };

            const response = await API.getCustomerVisitDetailsReport(payLoad);

            setCustomerData(response?.data?.data || []);
            setTotalPages(response?.data?.pagination?.total_pages || 1);
            setShowModal(true);

        } catch (error) {
            if (error?.response?.status === 403) {
                window.location.replace("/Login");
            }
            handleError(error);
        }

    };

    const handleWaiverClick = async (key, value, rowData, centerId) => {
        let number = 0;

        if (key.includes(">")) {
            number = parseInt(key.split(">")[1].trim());
        } else if (key.includes("=")) {
            number = parseInt(key.split("=")[1].trim());
        }
        ///  console.log('centerId', centerId, number)
        setCenterID(centerId)
        setSelectedRange(number);
        setCurrentPage(1);
        await fetchCustomerWaiverData(number, 1, centerId);
    };

    const fetchCustomerWaiverData = async (range, page, centerId) => {
        try {
            const payLoad = {
                range: range,
                mobile: null,
                date_from: search.from_date || formattedPastDate,
                date_to: search.to_date || formattedToday,
                page: page,
                page_size: 10,
                location_id: centerId
            };

            const response = await API.getCustomerWaiverDetailsReport(payLoad);
          //  console.log('rrrr', response?.data?.data, response?.data?.pagination?.total_pages);
            setCustomerWaiverData(response?.data?.data || []);
            setTotalPages(response?.data?.pagination?.total_pages || 1);
            setShowWaiverModal(true);

        } catch (error) {
            if (error?.response?.status === 403) {
                window.location.replace("/Login");
            }
            handleError(error);
        }

    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
            fetchCustomerData(selectedRange, newPage, centerID);
        }
    };

    const getPageNumbers = () => {
        const maxVisible = 10;
        const pageNumbers = [];
        if (totalPages <= maxVisible) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            const left = Math.max(1, currentPage - 3);
            const right = Math.min(totalPages, currentPage + 3);

            if (left > 2) {
                pageNumbers.push(1, "...");
            } else {
                for (let i = 1; i < left; i++) {
                    pageNumbers.push(i);
                }
            }
            for (let i = left; i <= right; i++) {
                pageNumbers.push(i);
            }
            if (right < totalPages - 1) {
                pageNumbers.push("...", totalPages);
            } else {
                for (let i = right + 1; i <= totalPages; i++) {
                    pageNumbers.push(i);
                }
            }
        }
        return pageNumbers;
    };

    return (
        <div>

            <div className="modern-nav-tabs">
                {tabs.map(tab => (
                    <div
                        key={tab.id}
                        className={`modern-tab ${activeTab === tab.id ? 'active' : ''}`}
                        onClick={() => handleTabChange(tab.id)}
                        style={{ marginRight: "10px" }}
                    >
                        <i className={tab.icon}></i>
                        {tab.label}
                    </div>
                ))}
            </div>

            <div style={{ marginTop: "20px" }}>

                <div className="row mt-3">
                    <div className="col-md-3">
                        <CenterModal onSelectCenter={handleSelectedCenter} resetTrigger={resetTrigger} key={resetTrigger} />
                    </div>
                    {/* {selectedReport !== "report3" && (
                        <> */}
                            <div className="col-md-3">
                                <label>From Date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={search.from_date || ""}
                                    max={formattedToday}
                                    onChange={(e) => handleFieldChange1(e, "from_date")}
                                />
                            </div>

                            <div className="col-md-3">
                                <label>To Date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={search.to_date || ""}
                                    min={search.from_date}
                                    max={
                                        search.from_date
                                            ? new Date(
                                                Math.min(
                                                    new Date(search.from_date).setDate(
                                                        new Date(search.from_date).getDate() + 90
                                                    ),
                                                    new Date()
                                                )
                                            )
                                                .toISOString()
                                                .split("T")[0]
                                            : formattedToday
                                    }
                                    onChange={(e) => handleFieldChange1(e, "to_date")}
                                />
                            </div>
                        {/* </>
                    )} */}
                    <div className="col-md-3 d-flex align-items-end">
                        <button className="btn btn-primary w-100" onClick={handleSearch}>
                            Search
                        </button>
                    </div>
                </div>
                <div className="mt-4">
                    {selectedReport === "report1" && (
                        <div className="card-body p-0 mt-4">
                            <div className="table-responsive">
                                <table className="table table-bordered mb-0 text-center">

                                    <thead className="table-light">
                                        <tr>
                                            <th>#</th>
                                            <th>Center Name</th>

                                            {analyticsReport.length > 0 &&
                                                Object.keys(analyticsReport[0])
                                                    .filter(
                                                        key => key !== "Center Name" && key !== "center_id"
                                                    )
                                                    .map((key, index) => (
                                                        <th key={index}>{key}</th>
                                                    ))}
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {analyticsReport && analyticsReport.length > 0 ? (
                                            analyticsReport.map((center, index) => (
                                                <tr key={index}>

                                                    <td>{index + 1}</td>

                                                    <td className="fw-semibold">
                                                        {center["Center Name"]}
                                                    </td>

                                                    {Object.keys(center)
                                                        .filter(
                                                            key => key !== "Center Name" && key !== "center_id"
                                                        )
                                                        .map((key, idx) => (
                                                            <td key={idx}>
                                                                <span
                                                                    style={{
                                                                        cursor: "pointer",
                                                                        color: "#0d6efd",
                                                                        fontWeight: "500"
                                                                    }}
                                                                    onClick={() =>
                                                                        handleClick(key, center[key], center, center.center_id)
                                                                    }
                                                                >
                                                                    {center[key]}
                                                                </span>
                                                            </td>
                                                        ))}
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="100%">No data available</td>
                                            </tr>
                                        )}
                                    </tbody>

                                </table>
                            </div>
                        </div>
                    )}

                    {selectedReport === "report2" && (
                        <div className="card-body p-0">
                            <div className="table-responsive">
                                <table className="table table-bordered mb-0 text-center">
                                    <thead className="table-light">
                                        <tr>
                                            <th>#</th>
                                            {profilingData?.length > 0 &&
                                                Object.keys(profilingData[0]).map((key, index) => (
                                                    <th key={index}>{key}</th>
                                                ))}
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {profilingData && profilingData.length > 0 ? (
                                            profilingData.map((row, rowIndex) => (
                                                <tr key={rowIndex}>
                                                    <td>{rowIndex + 1}</td>
                                                    {Object.keys(row).map((key, colIndex) => (
                                                        <td key={colIndex}>{row[key] ?? "N/A"}</td>
                                                    ))}
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="100%">No data available</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    )}

                    {selectedReport === "report3" && (
                        <div className="card mt-1" ref={tableRef}>
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <h4 className="card-title mb-0">Membership Summary</h4>
                                <button className="btn btn-primary btn-sm" onClick={downloadCSV}>
                                    <i className="fa fa-download"></i>
                                </button>
                            </div>

                            <div className="p-4">

                                {membershipCount && membershipCount.length > 0 ? (
                                    membershipCount.map((center, centerIndex) => (
                                        <div key={centerIndex} className="mb-4">
                                            <h5 className="mb-3 fw-bold text-primary">
                                                {center["Center Name"]}
                                            </h5>

                                            <div className="d-flex flex-wrap justify-content-between">
                                                {["Platinum", "Gold", "Silver", "Bronze"].map((plan, index) => {
                                                    const colors = [
                                                        "#e8e8ff",
                                                        "#fff0e6",
                                                        "#dceeff",
                                                        "#ffe6d9",
                                                    ];

                                                    return (
                                                        <div
                                                            key={plan}
                                                            style={{
                                                                backgroundColor: colors[index % colors.length],
                                                                padding: "15px",
                                                                borderRadius: "12px",
                                                                textAlign: "center",
                                                                flex: "0 0 23%",
                                                                marginBottom: "15px",
                                                            }}
                                                        >
                                                            <h6 className="fw-bold mb-1">
                                                                {center[plan] ?? 0}
                                                            </h6>
                                                            <small className="fw-semibold">{plan}</small>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div
                                        className="text-center p-4"
                                        style={{
                                            backgroundColor: "#f8f9fa",
                                            borderRadius: "12px",
                                        }}
                                    >
                                        No membership data available
                                    </div>
                                )}

                            </div>
                        </div>
                    )}

                    {selectedReport === "report4" && (
                        <div className="card mt-3" ref={tableRef}>
                            <div className="card-header">
                                <h4 className="card-title mb-0">Waiver Visit Frequency Summary</h4>
                            </div>

                            <div className="card-body p-0">
                                <div className="table-responsive">
                                    <table className="table table-bordered text-center mb-0">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Center Name</th>
                                                {waiverData.length > 0 &&
                                                    Object.keys(waiverData[0])
                                                        .filter(key => key !== "Center Name" && key !== "center_id")
                                                        .map((key, index) => (
                                                            <th key={index}>{key}</th>
                                                        ))}
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {waiverData.length > 0 ? (
                                                waiverData.map((row, rowIndex) => (
                                                    <tr key={rowIndex}>

                                                        {/* Center Name */}
                                                        <td className="fw-bold">
                                                            {row["Center Name"]}
                                                        </td>

                                                        {Object.keys(row)
                                                            .filter(
                                                                key => key !== "Center Name" && key !== "center_id"
                                                            )
                                                            .map((key, colIndex) => (
                                                                <td key={colIndex}>
                                                                    <span
                                                                        style={{
                                                                            cursor: "pointer",
                                                                            color: "#0d6efd",
                                                                            fontWeight: "500"
                                                                        }}
                                                                        onClick={() =>
                                                                            handleWaiverClick(
                                                                                key,
                                                                                row[key],
                                                                                row,
                                                                                row.center_id
                                                                            )
                                                                        }
                                                                    >
                                                                        {row[key]}
                                                                    </span>
                                                                </td>
                                                            ))}
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="10">No waiver data available</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {showModal && (
                <div className="modal show fade d-block">
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">

                            <div className="modal-header">
                                <h5 className="modal-title">Customer Details</h5>
                                <button
                                    className="btn-close"
                                    onClick={() => setShowModal(false)}
                                ></button>
                            </div>

                            <div className="modal-body">

                                <table className="table table-bordered text-center">
                                    <thead className="table-light">
                                        <tr>
                                            <th>#</th>
                                            <th>Mobile</th>
                                            <th>Membership</th>
                                            <th>Center</th>
                                            <th>Skycoin Spent</th>
                                            <th>Skycoin Buy</th>
                                            <th>Loyalty Redeem</th>
                                            <th>Last Visit</th>
                                            <th>Visit Count</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {customerData.length > 0 ? (
                                            customerData.map((item, i) => (
                                                <tr key={i}>
                                                    <td>{(currentPage - 1) * 10 + i + 1}</td>
                                                    <td>{item.mobile}</td>
                                                    <td>{item.membership}</td>
                                                    <td>{item.center_name}</td>
                                                    <td>{item.total_skycoin_spent}</td>
                                                    <td>{item.total_skycoin_buy}</td>
                                                    <td>{item.total_loyalty_point_redeem}</td>
                                                    <td>{item.last_visit_date || "-"}</td>
                                                    <td>{item.visit_count}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="9">No Data Found</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <nav aria-label="Page navigation example">
                                    <ul className="pagination justify-content-center mt-4">
                                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => handlePageChange(currentPage - 1)}
                                                disabled={currentPage === 1}
                                            >
                                                Previous
                                            </button>
                                        </li>

                                        {getPageNumbers().map((page, index) => (
                                            <li
                                                key={index}
                                                className={`page-item ${page === currentPage ? "active" : ""
                                                    } ${page === "..." ? "disabled" : ""}`}
                                            >
                                                {page === "..." ? (
                                                    <span className="page-link">...</span>
                                                ) : (
                                                    <button
                                                        className="page-link"
                                                        onClick={() => handlePageChange(page)}
                                                    >
                                                        {page}
                                                    </button>
                                                )}
                                            </li>
                                        ))}

                                        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => handlePageChange(currentPage + 1)}
                                                disabled={currentPage === totalPages}
                                            >
                                                Next
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>

                        </div>
                    </div>
                </div>
            )}


            {showWaiverModal && (
                <div className="modal show fade d-block">
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">

                            <div className="modal-header">
                                <h5 className="modal-title">Customer Details</h5>
                                <button
                                    className="btn-close"
                                    onClick={() => setShowWaiverModal(false)}
                                ></button>
                            </div>

                            <div className="modal-body">

                                <table className="table table-bordered text-center">
                                    <thead className="table-light">
                                        <tr>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>Mobile</th>
                                            <th>Membership</th>
                                            <th>Center</th>
                                            <th>Skycoin Spent</th>
                                            <th>Skycoin Buy</th>
                                            <th>Loyalty Redeem</th>
                                            <th>Last Visit</th>
                                            <th>Visit Count</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {customerWaiverData.length > 0 ? (
                                            customerWaiverData.map((item, i) => (
                                                <tr key={i}>
                                                    <td>{(currentPage - 1) * 10 + i + 1}</td>
                                                    <td>{item.customer_name || "-"}</td>
                                                    <td>{item.mobile}</td>
                                                    <td>{item.membership}</td>
                                                    <td>{item.center_name}</td>
                                                    <td>{item.total_skycoin_spent}</td>
                                                    <td>{item.total_skycoin_buy}</td>
                                                    <td>{item.total_loyalty_point_redeem}</td>
                                                    <td>{item.last_visit_date}</td>
                                                    <td>{item.visit_count}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="9">No Data Found</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <nav aria-label="Page navigation example">
                                    <ul className="pagination justify-content-center mt-4">
                                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => handlePageChange(currentPage - 1)}
                                                disabled={currentPage === 1}
                                            >
                                                Previous
                                            </button>
                                        </li>

                                        {getPageNumbers().map((page, index) => (
                                            <li
                                                key={index}
                                                className={`page-item ${page === currentPage ? "active" : ""
                                                    } ${page === "..." ? "disabled" : ""}`}
                                            >
                                                {page === "..." ? (
                                                    <span className="page-link">...</span>
                                                ) : (
                                                    <button
                                                        className="page-link"
                                                        onClick={() => handlePageChange(page)}
                                                    >
                                                        {page}
                                                    </button>
                                                )}
                                            </li>
                                        ))}

                                        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => handlePageChange(currentPage + 1)}
                                                disabled={currentPage === totalPages}
                                            >
                                                Next
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>

                        </div>
                    </div>
                </div>
            )}
            <ToastContainer />
        </div >
    );
};

export default CustomerAnalyticsReport;
